export interface JsonPatchOperationModel {
  op: 'remove' | 'add' | 'replace';
  path: string;
  value: string | boolean | object | number;
}
